module.exports = __webpack_public_path__ + "media/src/application/media/poster-7e22b7ec194de4badcf6ae08a60dcca1.png";